<template class="">
  <vs-row vs-type="flex" vs-justify="center">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
       <vs-chip class="ag-grid-cell-chip shadow w-full"  :color="getOrderStatusColor(params.data.meta.paid)">
        {{ params.data.meta.paid ? "Pagada" : "Pendiente" }}
      </vs-chip>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'active') return 'success'
        else if (value === 'blocked') return 'danger'
        else if (value === 'deactivated') return 'warning'
        else return 'primary'
      }
    }
  },
  methods: {
    getOrderStatusColor (status) {
      if (status)   return 'success'
      else  return 'danger'
      return 'primary'
    },
  }
}
</script>

<style scoped>
.status-chip{
    height: 10%;
    margin-top: 10px;
}
</style>